<template>
  <div>
    <div class="header">
      <img src="../../assets/images/home/logo.png" alt @click="retrungo()" />
      <span style="cursor: pointer;margin-left:5px" @click="retrungo()">{{biaoTi}}</span>
    </div>
    <llogin @login="clikLogin"></llogin>

    <el-dialog :visible.sync="loginVisible" width="30%" :before-close="handleClose">
      <login @closeAlert="handleClose"></login>
    </el-dialog>
  </div>
</template>
<script>
import llogin from './login';
import Login from '@/views/login/Login';
export default {
  components: {
    llogin,
    Login,
  },
  data() {
    return {
      biaoTi: localStorage.getItem('biaoti'),
      loginVisible: false,
      smallFlag: false,
    };
  },
  created() {
    window.clikLogin = this.clikLogin;
  },
  methods: {
    clikLogin() {
      this.loginVisible = !this.loginVisible;
    },
    handleClose() {
      this.loginVisible = false;
    },
    retrungo() {
      // 如果为个人中心的页面点击返回主页，不是则返回上一页
      if (this.$route.matched[0].path == '/personCenter') {
        this.$router.push('/home');
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  height: 60px;
  width: 100%;
  background-color: #324160;
  box-sizing: border-box;
  border-radius: 0px;
  line-height: 60px;
  font-size: 24px;
  color: #fff;
  display: flex;
  align-items: center;
}

img {
  margin-left: 18%;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  cursor: pointer;
}
</style>